import React from "react"
import { StaticImage } from "gatsby-plugin-image"
import clsx from "clsx"

import { ArrowButton } from "components"

function ListItem({ label, link, currentSlug }) {
  const HREF = link?.link

  return (
    <li>
      {link?.link === "/products/" + currentSlug + "/" ? (
        <span className="text-violet h5">{label.split(" | ")[0]}</span>
      ) : (
        <ArrowButton label={label.split(" | ")[0]} href={HREF} className="h5" />
      )}
    </li>
  )
}

function Footer({ categoryList, colorTheme, slug, fillerText }) {
  return (
    <footer className="ring-1 ring-mineralGray wrapper mt-14 lg:mt-24 relative overflow-hidden">
      <div className="lg:flex-row lg:space-y-0 lg:space-x-px relative flex flex-col space-y-px">
        <div className="flex-1">
          <div className="sm:-mx-fluidMargin xl:-ml-26 lg:mr-0 h-full -mx-6">
            <div className="ring-1 ring-mineralGray relative flex items-center justify-center h-full">
              <div
                className={clsx(
                  "absolute top-0 bottom-0 left-0 right-0 w-full h-full",
                  colorTheme === "Purple" && "bg-violet",
                  colorTheme === "Blue" && "bg-blue",
                  colorTheme === "Red" && "bg-red",
                  colorTheme === "Yellow" && "bg-gold"
                )}
              >
                {colorTheme === "Purple" && (
                  <StaticImage
                    className="absolute top-0 bottom-0 left-0 right-0 w-full h-full"
                    src="../../../assets/product-categories/jelly@2x.jpg"
                    width={768}
                    quality={80}
                    placeholder="blurred"
                    alt="Jelly very close"
                    objectFit="cover"
                    objectPosition="center"
                    backgroundColor="#8e426c"
                    style={{ position: "absolute" }}
                  />
                )}
                {colorTheme === "Blue" && (
                  <StaticImage
                    className="absolute top-0 bottom-0 left-0 right-0 w-full h-full"
                    src="../../../assets/product-categories/plastic@2x.jpg"
                    width={768}
                    quality={80}
                    placeholder="blurred"
                    alt="Plastic very close"
                    objectFit="cover"
                    objectPosition="center"
                    backgroundColor="#4a91cb"
                    style={{ position: "absolute" }}
                  />
                )}
                {colorTheme === "Red" && (
                  <StaticImage
                    className="absolute top-0 bottom-0 left-0 right-0 w-full h-full"
                    src="../../../assets/product-categories/jam@2x.jpg"
                    width={768}
                    quality={80}
                    placeholder="blurred"
                    alt="Jam very close"
                    objectFit="cover"
                    objectPosition="center"
                    backgroundColor="#bf4944"
                    style={{ position: "absolute" }}
                  />
                )}
                {colorTheme === "Yellow" && (
                  <StaticImage
                    className="absolute top-0 bottom-0 left-0 right-0 w-full h-full"
                    src="../../../assets/product-categories/honey@2x.jpg"
                    width={768}
                    quality={80}
                    placeholder="blurred"
                    alt="Honey very close"
                    objectFit="cover"
                    objectPosition="center"
                    backgroundColor="#c48f46"
                    style={{ position: "absolute" }}
                  />
                )}
              </div>
              {fillerText && (
                <p className="px-14 sm:px-fluidMargin lg:px-14 h2 relative py-8 text-center text-white">
                  {fillerText}
                </p>
              )}
            </div>
          </div>
        </div>
        <div className="flex-1">
          <div className="sm:-mx-fluidMargin xl:-mr-26 lg:ml-0 relative flex-1 -mx-6">
            <div className="md:space-y-8 sm:px-fluidMargin xl:px-26 md:py-24 bg-lightBlue ring-1 ring-mineralGray px-6 py-8 -mr-px space-y-4">
              <h2 className="cap-subtitle text-mineralGray">
                Explore products and capabilities
              </h2>
              <ul className="md:space-y-5 space-y-4">
                {categoryList?.links?.map((link, i) => (
                  <ListItem
                    currentSlug={slug}
                    {...link}
                    key={`category--${i}`}
                  />
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
